import { render, staticRenderFns } from "./baseInfoWrap.vue?vue&type=template&id=b8b6e986&scoped=true"
import script from "./baseInfoWrap.vue?vue&type=script&lang=js"
export * from "./baseInfoWrap.vue?vue&type=script&lang=js"
import style0 from "./baseInfoWrap.vue?vue&type=style&index=0&id=b8b6e986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6e986",
  null
  
)

export default component.exports